import React from 'react';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
import { MobileActionBar } from '../components/layout/MobileActionBar';
import { AnswerNeeds } from '../components/sections/AnswerNeeds';
import { Faq } from '../components/sections/Faq';
import { FinalLead } from '../components/sections/FinalLead';
import { GoogleReviews } from '../components/sections/GoogleReviews';
import { Hero } from '../components/sections/Hero';
import { PlannerPack } from '../components/sections/PlannerPack';
import { Process } from '../components/sections/Process';
import { QuoteForm } from '../components/sections/QuoteForm';
import { SecondaryServices } from '../components/sections/SecondaryServices';
import { ShutterOptions } from '../components/sections/ShutterOptions';
import { TestimonialsWhy } from '../components/sections/TestimonialsWhy';
import { WorkGallery } from '../components/sections/WorkGallery';
export function Home() {
  return <div className="min-h-screen w-full bg-neutral-canvas" data-id="element-557" data-mp="30xb71x5voltk">
      <Header data-id="element-558" data-mp="30uozhxizm6bc" />
      <main data-id="element-559" data-mp="2vxou7otyp7la">
        <Hero data-id="element-560" data-mp="2vxydktki4gi0" />
        <GoogleReviews data-id="element-561" data-mp="2vxf503gqr4gn" />
        <WorkGallery data-id="element-562" data-mp="2vy836g1mwln6" />
        <AnswerNeeds data-id="element-563" data-mp="2vvlta9r9tu1s" />
        <TestimonialsWhy data-id="element-564" data-mp="2qybxmcdagm5i" />
        <ShutterOptions data-id="element-565" data-mp="2qxu1rgujg9y4" />
        <Process data-id="element-566" data-mp="2qx0vegzhrmgi" />
        <QuoteForm data-id="element-567" data-mp="2r0ondbpag0t4" />
        <PlannerPack data-id="element-568" data-mp="2mx0gkv8hd98x" />
        <SecondaryServices data-id="element-569" data-mp="2mxs0v9wmnkjw" />
        <Faq data-id="element-570" data-mp="2mwgy9dex4iud" />
        <FinalLead data-id="element-571" data-mp="2mwqrd9v9f64a" />
      </main>
      <Footer data-id="element-572" data-mp="2hxnj7gjzgjs3" />
      <MobileActionBar data-id="element-573" data-mp="2hyfcgkq3y5f7" />
    </div>;
}